import lodashSortBy from 'lodash/sortBy'
import type { AddToDiscoObject, Business } from 'types/public-playlist'
import {
  ADD_TO_DISCO,
  ADD_TO_DISCO_CHOOSE_BUSINESS,
  ADD_TO_DISCO_CHOOSE_CANCEL,
  ADD_TO_DISCO_ERROR,
  ADD_TO_DISCO_SUCCESS,
  USER_LOGIN_REQUIRE_MFA,
} from '@disco/constants/ActionTypes'

function updateAddToDisco(
  state: AddToDiscoState,
  key: string,
  value: AddToDiscoItem,
) {
  return {
    ...state,
    addToDiscoItems: { ...state.addToDiscoItems, [key]: value },
  }
}

type AddToDiscoItem = {
  status: 'NOT_ADDED' | 'ADDING' | 'ADDED' | 'ERROR'
  destBusiness: Record<string, any> | null | undefined
  error?: Error | null | undefined
  object?: AddToDiscoObject | null | undefined
  mixpanelEventDetails?: Record<string, any> | null | undefined
}
export type AddToDiscoState = {
  addToDiscoItems: Record<string, AddToDiscoItem>
  addToDiscoModal:
    | {
        businesses: Array<Business>
        object: AddToDiscoObject | null
        shown: boolean
        success: boolean
        mixpanelEventDetails: Record<string, any>
      }
    | null
    | undefined
}
const initialState: AddToDiscoState = {
  addToDiscoItems: {},
  addToDiscoModal: null,
}
export function addToDiscoReducer(
  state: AddToDiscoState = initialState,
  action: any,
): any {
  switch (action.type) {
    case ADD_TO_DISCO: {
      let extra = {}

      if (action.destBusiness) {
        extra = {
          addToDiscoModal: { ...state.addToDiscoModal, shown: false },
        }
      }

      return {
        ...updateAddToDisco(state, action.objectKey, {
          status: 'ADDING',
          destBusiness: action.destBusiness,
        }),
        ...extra,
      }
    }

    case ADD_TO_DISCO_CHOOSE_BUSINESS:
      return {
        ...updateAddToDisco(state, action.objectKey, {
          status: 'NOT_ADDED',
          destBusiness: action.destBusiness,
        }),
        addToDiscoModal: {
          // businesses are in different order in cookies and API
          businesses: lodashSortBy(action.businesses, 'id'),
          object: action.object,
          mixpanelEventDetails: action?.mixpanelEventDetails,
          shown: true,
        },
      }

    case ADD_TO_DISCO_CHOOSE_CANCEL:
      return { ...state, addToDiscoModal: null }

    case ADD_TO_DISCO_SUCCESS: {
      let extra = {}

      if (action.showModalSuccessDialog) {
        extra = {
          addToDiscoModal: {
            ...state.addToDiscoModal,
            success: true,
            shown: true,
          },
        }
      }

      return {
        ...updateAddToDisco(state, action.objectKey, {
          status: 'ADDED',
          destBusiness: action.destBusiness,
        }),
        ...extra,
        redirect_url: action.redirect_url,
      }
    }

    case ADD_TO_DISCO_ERROR: {
      let extra = {}

      if (action.error.code === 'ADD_TO_DISCO_ERROR_UNAUTHORIZED') {
        extra = {
          addToDiscoModal: {
            businesses: [],
            object: action.object,
            mixpanelEventDetails: action?.mixpanelEventDetails,
            shown: true,
          },
        }
      } else if (action.error.code) {
        extra = {
          addToDiscoModal: { ...state.addToDiscoModal, shown: true },
        }
      } else {
        extra = {
          addToDiscoModal: null,
        }
      }

      return {
        ...updateAddToDisco(state, action.objectKey, {
          status: 'ERROR',
          error: action.error,
          object: action.object,
          mixpanelEventDetails: action?.mixpanelEventDetails,
          destBusiness: action.destBusiness,
        }),
        ...extra,
      }
    }

    case USER_LOGIN_REQUIRE_MFA: {
      return {
        ...state,
        addToDiscoModal: { ...state.addToDiscoModal, shown: true },
      }
    }

    default:
      return state
  }
}
